export default {
  data(){
    return{
      unRefresh:false
    }
  },
  methods:{
    handleScroll(e){
      this.unRefresh = e.target.scrollTop > 10
    }
  }
}
